import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import ChairRentalPaymentRefundButton from '../components/ChairRentalPaymentRefundButton';
import { refundChairRentalPayment } from '../actions';
import withToggle from '../../../../common/hoc/withToggle';
import confirmModal from '../../../../common/confirmModal';

const mapDispatchToProps = {
  refundChairRentalPayment,
};

export default compose(
  connect(null, mapDispatchToProps),
  withToggle(),
  withHandlers({
    refund: props => () => confirmModal({
      title: '',
      message: 'Are you sure you want to refund this payment?',
      type: 'yesno',
      confirmButtonText: 'Yes',
      negativeButtonText: 'No',
    },
    () => props.refundChairRentalPayment(props.barberId, props.payment.id)
      .then(() => props.addNotification({
        level: 'success',
        message: 'Payment sucessfully refunded.',
        title: 'Success',
      }))
      .then(() => props.off())
      .catch(() => props.off()),
    () => props.off()
    ),
  })
)(ChairRentalPaymentRefundButton);
